<form
  [formGroup]="form"
  autocomplete="off"
  (ngSubmit)="saveMediaCategoryName()"
>
  <div class="media-category-names-popup">
    <div class="modal-header ps-4 pe-4">
      <h5 class="modal-title" id="modal-basic-title">
        {{ data?.category?.name }}
      </h5>
      <button
        type="button"
        class="btn-close fs-13"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="table-scroll table-responsive data-grid">
        <ng-container formArrayName="mediaCategoryNames">
          <table
            #table
            mat-table
            [dataSource]="mediaCategoryNames.controls"
            class="table"
          >
            <ng-container matColumnDef="alternateName">
              <th
                mat-header-cell
                class="name-heading w-15-rem"
                *matHeaderCellDef
              >
                Category Name
              </th>
              <td
                mat-cell
                *matCellDef="let element; let categoryIndex = index"
                [formGroup]="element"
                class="less-height-2-rem p-2"
              >
                <input
                  formControlName="alternateName"
                  class="form-control"
                  placeholder="Alternate Name"
                  [ngClass]="{
                    'border border-danger':
                      element.controls['alternateName'].errors?.required &&
                      element.controls['alternateName'].invalid &&
                      (element.controls['alternateName'].dirty ||
                        element.controls['alternateName'].touched)
                  }"
                />
              </td>
            </ng-container>

            <ng-container matColumnDef="comments">
              <th
                mat-header-cell
                class="comments-heading w-15-rem"
                *matHeaderCellDef
              >
                Comments
              </th>
              <td
                mat-cell
                *matCellDef="let element; let categoryIndex = index"
                [formGroup]="element"
                class="less-height-2-rem p-2"
              >
                <input
                  formControlName="comments"
                  class="form-control"
                  placeholder="Comments"
                />
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th
                mat-header-cell
                class="action-heading w-3-rem"
                *matHeaderCellDef
              >
                Action
              </th>
              <td
                mat-cell
                *matCellDef="let element; let categoryIndex = index"
                class="ps-2"
              >
                <button
                  type="button"
                  (click)="delete(element, categoryIndex)"
                  class="btn btn-outline-danger btn-sm"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns$.value"></tr>
            <tr
              mat-row
              *matRowDef="
                let row;
                columns: displayedColumns$.value;
                let categoryIndex = index
              "
              class="border-start-0 border-end-0 pointer pt-2"
            ></tr>
          </table>
        </ng-container>

        <!--<div class="col-md-12 text-center" *ngIf="isLoader">
          Loading <i class="fa fa-spinner fa-spin"></i>
        </div>-->
      </div>

      <div class="ps-3">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          (click)="addRow()"
        >
          <i class="fa fa-plus"></i> Add
        </button>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-primary btn-sm"
        [disabled]="!form.dirty || form.invalid"
      >
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>
</form>
